import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DemoItem } from "@mui/x-date-pickers/internals/demo"; // Remove DemoContainer import
import dayjs from "dayjs";
import * as React from "react";
import { useEffect, useState } from "react";

export default function ResponsiveDatePickers({
  defaultValue,
  label,
  onChange,
  minDate,
  maxDate,
}) {
  const [selectedDate, setSelectedDate] = useState(dayjs(defaultValue));

  useEffect(() => {
    setSelectedDate(dayjs(defaultValue));
  }, [defaultValue]);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    if (onChange) {
      onChange(date);
    }
  };

  const minDayjs = dayjs(minDate);
  const maxDayjs = dayjs(maxDate);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoItem label={label}>
        <DesktopDatePicker
          value={selectedDate}
          onChange={handleDateChange}
          // minDate={minDayjs.isValid() ? minDayjs : null}
          // maxDate={maxDayjs.isValid() ? maxDayjs : null}
          sx={{
            border: "1px solid #fAfAfA",
            "& .MuiInputBase-root": {
              width: "100%",
              border: "1px solid #fAfAfA",
              borderRadius: "25px",
              backgroundColor: "white",
              fontSize: "15px",
            },
            "& .MuiInputBase-input.MuiOutlinedInput-input": {
              padding: "6px 12px",
            },
          }}
        />
      </DemoItem>
    </LocalizationProvider>
  );
}
